// data-tables activator
$(document).ready(function () {
    $.fn.dataTable.moment('MM/DD/YYYY');
    $.fn.dataTable.moment('M/D/YYYY');
    //$.fn.dataTable.moment('MMM D, YYYY');
    //$.fn.dataTable.moment('MMMM D, YYYY');

    $('.data-table > table').DataTable({
        //"filter": false,
        //"info": false,
        //"paging": false
    });

    $('.data-table-desc > table').DataTable({
        order: [[ 0, "desc" ]]
        //"filter": false,
        //"info": false,
        //"paging": false
    });
});